export const formatDelta = (delta: number): string => {
  const sign = delta >= 0 ? "↑" : "↓";
  return `${sign} ${Math.abs(delta).toFixed(1)}`;
};
